import React, {useState,useEffect} from 'react'
import './MyProductsActives.scss'
import Loader from '../../Atoms/Loader/Loader';
import { withRouter} from 'react-router-dom'
import { connect } from 'react-redux'
import {useTranslation} from 'react-i18next';
import MyProductCard2 from '../../Molecules/MyProductCard/MyProductCard2'
import notProduct from '../../../assets/P1-Tienda-sin-articulos-imagen.png';
import { useProducts } from '../../../customHooks/useProducts'
import { Button } from 'antd';

const MyProductsActives = (props) => {
  const { t } = useTranslation();
  const [reload, setReload] = useState(false)
  const { loadingProducts, products, productsCount, setPage } = useProducts({storeId: props.userInfo.store.id, status: 1, switchBloqued: 1})

  useEffect(() => {
    document.body.scrollIntoView({block:'start'})
    setReload(false)
  }, [])

  // Validar producto
  const validProduct = (array, message) => {
    let result = false
    array &&
    array.forEach(product=> {
      if(product.status === message) {
        result = true
      }
    })
    return result
  }

  let productAvailable = validProduct(products, "Disponible")

  return (
    <>
    <div className="profile-container">
    <div className="wrapped-profile-container">
      {
      loadingProducts ? <Loader /> : 
      products.length < 1 ? 
      <div className="box container-products-actives">
        <div className="main-empty">
          <h2 className="title-main-empty-product">{t("no-loaded-products", {a: ' '})}</h2>
          <img src={notProduct} alt={t("no-loaded-products", {a: ' '})}/>
        </div> 
      </div> :
      <>
        {productAvailable &&
        <div className="box container-products-actives">
          <h2 className='center-text title-form title-profilePicture'>{t("active-products", {a: ' '})}</h2>
          <div className="products-container">
            {
              products.map(product => (
                product.status === 'Disponible' &&
                <>
                <MyProductCard2 key={product.id}
                  product={product}
                  setReload={setReload}
                  reload={reload}
                  active
                />
                </>
              ))
            }
            {products.length < productsCount && <Button type='primary' onClick={() => setPage(prevPage => prevPage + 1)} className='round-button btn-first pagination-button'>Cargar más</Button>}
          </div>
        </div>
        }
        <div>
          {
            !productAvailable &&
            <div className="box container-products-actives">
              <div className="main-empty">
                <h2 className="title-main-empty-product">{t("no-active-products", {a: ' '})}</h2>
                <img src={notProduct} alt={t("no-active-products", {a: ' '})}/>
              </div> 
            </div>
          }
        </div>
      </>
      }
    </div>
    </div>
  </>
  )
}

const mapStateToProps = (state) => ({
  userInfo: state.userReducer.userInfo
})
export default withRouter(connect(mapStateToProps)(MyProductsActives)) 

